enum ActionTypes {
    GET_PROJECT_ACTIVITIES = "projectActivities/get",
    SET_PROJECT_ACTIVITIES = "projectActivities/set",
    UPDATE_PROJECT_ACTIVITIES = "projectActivities/update",
}

export default ActionTypes;
